<template>
  <main>
    <div class="container narrow">
      <div
        class="main-content-box d-flex flex-column align-items-center justify-content-center play-dropdown"
      >
        <div class="top-page-divider w-100">
          <h2
            class="page-title center h2 font-weight-bold lh-1 mt-3 mb-0 text-primary"
          >
            DOWNLOAD
          </h2>
          <h2
            class="page-title center h1 font-weight-bold lh-1 mb-0 mt-0 text-white"
          >
            THE GAME
          </h2>
        </div>
        <div class="play-dropdown">
          <div class="dropdown">
            <a
              id="WindowsMenu"
              class="dropdown-toggle btn green large px-5"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              data-bs-display="static"
              aria-expanded="false"
            >
              Download for
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                height="20"
                width="20"
                class="mx-2"
              >
                <g fill="currentColor">
                  <rect
                    x="1"
                    y="1"
                    fill="currentColor"
                    width="10"
                    height="10"
                  />
                  <rect
                    x="13"
                    y="1"
                    transform="matrix(-1 -4.492907e-11 4.492907e-11 -1 36 12)"
                    fill="currentColor"
                    width="10"
                    height="10"
                  />
                  <rect
                    x="1"
                    y="13"
                    fill="currentColor"
                    width="10"
                    height="10"
                  />
                  <rect
                    x="13"
                    y="13"
                    transform="matrix(-1 -4.492907e-11 4.492907e-11 -1 36 36)"
                    fill="currentColor"
                    width="10"
                    height="10"
                  />
                </g>
              </svg>
              Windows
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end py-3"
              aria-labelledby="WindowsMenu"
            >
              <li class="dropdown-item mb-2">
                <a
                  href="https://static.near-reality.com/NearReality.exe"
                  target="_blank"
                  file
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    height="20"
                    width="20"
                    class="mr-2"
                  >
                    <g fill="currentColor">
                      <rect
                        x="1"
                        y="1"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                      <rect
                        x="13"
                        y="1"
                        transform="matrix(-1 -4.492907e-11 4.492907e-11 -1 36 12)"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                      <rect
                        x="1"
                        y="13"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                      <rect
                        x="13"
                        y="13"
                        transform="matrix(-1 -4.492907e-11 4.492907e-11 -1 36 36)"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                    </g>
                  </svg>
                  Windows Base
                </a>
              </li>
              <li class="dropdown-item mb-2">
                <a
                  href="https://static.near-reality.com/NearReality32.exe"
                  target="_blank"
                  file
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    height="20"
                    width="20"
                    class="mr-2"
                  >
                    <g fill="currentColor">
                      <rect
                        x="1"
                        y="1"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                      <rect
                        x="13"
                        y="1"
                        transform="matrix(-1 -4.492907e-11 4.492907e-11 -1 36 12)"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                      <rect
                        x="1"
                        y="13"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                      <rect
                        x="13"
                        y="13"
                        transform="matrix(-1 -4.492907e-11 4.492907e-11 -1 36 36)"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                    </g>
                  </svg>
                  Windows 32-bit
                </a>
              </li>
              <li class="dropdown-item">
                <a
                  href="https://static.near-reality.com/NearRealityAArch64.exe"
                  target="_blank"
                  file
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    height="20"
                    width="20"
                    class="mr-2"
                  >
                    <g fill="currentColor">
                      <rect
                        x="1"
                        y="1"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                      <rect
                        x="13"
                        y="1"
                        transform="matrix(-1 -4.492907e-11 4.492907e-11 -1 36 12)"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                      <rect
                        x="1"
                        y="13"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                      <rect
                        x="13"
                        y="13"
                        transform="matrix(-1 -4.492907e-11 4.492907e-11 -1 36 36)"
                        fill="currentColor"
                        width="10"
                        height="10"
                      />
                    </g>
                  </svg>
                  Windows Arm
                </a>
              </li>
            </ul>
          </div>
        </div>
        <h5 class="content-box--heading mt-5 mb-0 px-3">
          Game is also available on:
        </h5>
        <div
          class="d-flex flex-row justify-content-center align-items-center mt-4 mb-5"
        >
          <div
            class="d-flex flex-column align-items-center justify-content-center text-center mx-2 play-dropdown mac-dropdown"
          >
            <div class="dropdown">
              <a
                id="LinuxMenu"
                class="dropdown-toggle bg-transparent d-flex flex-column align-items-center justify-content-center"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                data-bs-display="static"
                aria-expanded="false"
              >
                <div class="btn p-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                    height="48"
                    width="48"
                  >
                    <g fill="currentColor">
                      <path
                        d="M43.622,39.658a2.121,2.121,0,0,0-1.1-1.267c-1.186-.679-1.949-1.438-2.093-2.082a6.384,6.384,0,0,1-.111-.763,2.516,2.516,0,0,0-.843-1.954,2,2,0,0,0-.643-.3,10.857,10.857,0,0,0,.4-4.324,16.048,16.048,0,0,0-3.537-8.3c-1.8-1.985-4.583-4.836-4.583-7V7.659a6.659,6.659,0,0,0-13.318,0v8.752c-.289,1.516-1.047,1.66-2.238,3.32a19.872,19.872,0,0,0-2.779,5.125c-.577,1.733-1.84,3.573-2.346,4.981a4.687,4.687,0,0,0-.205,2.767,8.383,8.383,0,0,0-.672.911,4.268,4.268,0,0,1-.562.738,3.839,3.839,0,0,1-1.182.167,3.446,3.446,0,0,0-2.328.646c-.586.627-.478,1.891-.364,3.228a10.051,10.051,0,0,1,.064,1.588,4.143,4.143,0,0,1-.5,1.522,2.927,2.927,0,0,0-.34.918,1.939,1.939,0,0,0,1.532,2.146c1.106.393,5.187,1.414,6.578,1.725a8.76,8.76,0,0,1,1.027.351,9.09,9.09,0,0,0,3.089.757A2.891,2.891,0,0,0,19.2,45.847a4.605,4.605,0,0,0,.446-.978,24.633,24.633,0,0,1,10.035.264,3.779,3.779,0,0,0,1.5,1.806,3.247,3.247,0,0,0,1.833.564,5.3,5.3,0,0,0,3.51-1.657,13.788,13.788,0,0,1,3.425-2.566c.778-.318,2.913-1.338,3.44-2.228A1.8,1.8,0,0,0,43.622,39.658ZM19.2,13.642c.348-.6,2.2-2.132,3.417-2.132a4.318,4.318,0,0,1,2.026.745,4.648,4.648,0,0,0,.974.469c.132.037.274.07.419.1.555.129,1.129.263,1.337.654a.643.643,0,0,1,.035.516,1.849,1.849,0,0,1-.973.967,8.209,8.209,0,0,0-1.066.694,5.107,5.107,0,0,1-2.944,1.275,2.952,2.952,0,0,1-2.323-1.456,4.421,4.421,0,0,0-.663-.721C18.92,14.343,18.924,14.126,19.2,13.642ZM25.64,7.328c1.2,0,2.177,1.4,2.177,3.116a4.067,4.067,0,0,1-.4,1.787,5.166,5.166,0,0,0-1.152-.377l-.015,0A1.766,1.766,0,0,0,26.7,10.7c.03-.826-.418-1.514-1-1.535s-1.081.631-1.111,1.458a2.071,2.071,0,0,0,.042.478,5.592,5.592,0,0,0-1.146-.462c0-.066-.018-.127-.018-.194C23.462,8.723,24.437,7.328,25.64,7.328Zm-5.813.5c1-.084,1.911,1.021,2.033,2.468.009.113.007.223,0,.333a4.827,4.827,0,0,0-.795.3,1.829,1.829,0,0,0-.007-.338c-.118-.738-.629-1.27-1.14-1.188s-.831.746-.713,1.484a1.665,1.665,0,0,0,.446.922c-.241.188-.466.377-.658.561a3.674,3.674,0,0,1-.581-1.784C18.3,9.136,18.826,7.908,19.827,7.824Zm-1.482,37.5c-.924,1.5-2.588,1.019-4.508.286a9.376,9.376,0,0,0-1.165-.392c-1.335-.3-5.408-1.317-6.463-1.691-.856-.3-.917-.737-.874-1.079a2.346,2.346,0,0,1,.243-.6,5.126,5.126,0,0,0,.6-1.872,10.785,10.785,0,0,0-.063-1.77c-.073-.859-.184-2.158.1-2.461.235-.251,1.055-.3,1.653-.329a3.13,3.13,0,0,0,1.767-.4,4.578,4.578,0,0,0,.752-.951c.316-.472.748-1.12,1.1-1.177a.777.777,0,0,1,.109-.008c.516,0,1.188.556,1.823,1.522.176.266.454.732.793,1.3a41.916,41.916,0,0,0,3.266,4.939C18.979,42.36,19.253,43.847,18.345,45.323Zm1.1-3.472a7.372,7.372,0,0,0-1.214-1.865c-.094-.107-.2-.235-.3-.365a1.387,1.387,0,0,0,1.086-.4c.541-.794-.144-2.13-1.047-2.849s-3.08-2.039-4.331-3.9c-.4-4.006,2.6-8.951,4.151-11.73a8.162,8.162,0,0,0,1.345-4.864c.061.074.121.146.185.226a3.9,3.9,0,0,0,3.1,1.83,5.979,5.979,0,0,0,3.53-1.465,7.509,7.509,0,0,1,.928-.61,3.413,3.413,0,0,0,.863-.615,86.349,86.349,0,0,1,4.231,9.107,24.676,24.676,0,0,1,.787,8.381c-.933-.1-1.737-.16-2.178.232-.523.465-.446,1.494-.372,2.489.015.218.031.421.036.594.015.5-.064,1.906-.165,3.107a8.282,8.282,0,0,1-6.68,3.387A11.094,11.094,0,0,1,19.447,41.851Zm23.074-1.309a8.7,8.7,0,0,1-2.959,1.812,14.7,14.7,0,0,0-3.746,2.777c-.376.368-2.34,2.14-4.088.976-1.719-1.146-1.409-2.93-.982-4.512.061-.227.111-.419.138-.565a44.4,44.4,0,0,0,.369-5.012c-.006-.186-.022-.406-.039-.638a5.007,5.007,0,0,1,.032-1.663,4.946,4.946,0,0,1,1.631.032c.344.038.684.075.981.089l.529.017c.98.032,3.962.126,4.48.528.343.265.394.616.461,1.265a7.516,7.516,0,0,0,.128.879c.269,1.194,1.548,2.144,2.574,2.732a1.251,1.251,0,0,1,.625.654A.821.821,0,0,1,42.521,40.542Z"
                        fill="currentColor"
                      ></path>
                    </g>
                  </svg>
                </div>
                <span class="sr-only">Download for Linux</span>
                <span class="mt-2 text-primary">Linux</span>
              </a>
              <ul
                class="dropdown-menu dropdown-menu-end py-3"
                aria-labelledby="LinuxMenu"
              >
                <li class="dropdown-item mb-2">
                  <a
                    href="https://static.near-reality.com/Near-Reality-x86_64.AppImage"
                    target="_blank"
                    file
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      class="mr-2"
                    >
                      <g fill="currentColor">
                        <path
                          d="M16.59,15.359a4.464,4.464,0,0,1,.979.432c.067.037.13.076.192.108.16-.015.419-.069.633-.114a5.774,5.774,0,0,1,1.171-.162,2.413,2.413,0,0,1,.4.035,7.268,7.268,0,0,0-.022-1.065A8.384,8.384,0,0,0,18.1,10.262c-.942-1.035-2.391-2.523-2.391-3.653V3.474a3.475,3.475,0,0,0-6.949,0V8.041c-.151.79-.546.866-1.167,1.732a10.318,10.318,0,0,0-1.45,2.674c-.29.87-.905,1.788-1.186,2.511a2.034,2.034,0,0,1,.23-.057,2.183,2.183,0,0,1,.34-.027,2.293,2.293,0,0,1,1.139.313A16.567,16.567,0,0,1,8.763,10.3a4.509,4.509,0,0,0,.7-2.918c.364.29.727,1.192,1.719,1.192S12.837,7.8,13.389,7.52a1.5,1.5,0,0,0,.382-.274l.095.022a46.862,46.862,0,0,1,2.3,4.915A11.1,11.1,0,0,1,16.59,15.359ZM10.94,5.274a2.247,2.247,0,0,0-.466.148l-.077.036a2.478,2.478,0,0,0-.376.216h0a1.325,1.325,0,0,1-.342-.826c-.049-.58.205-1.076.566-1.106s.693.416.742,1A1.571,1.571,0,0,1,10.94,5.274Zm2.4-.418a1.6,1.6,0,0,1-.279.8c-.057-.03-.12-.061-.185-.092l-.049-.024c-.078-.036-.162-.07-.252-.1l-.01,0a3.2,3.2,0,0,0-.678-.167,1.77,1.77,0,0,1-.038-.537c.055-.654.433-1.156.845-1.121S13.4,4.2,13.34,4.856Z"
                          fill="currentColor"
                        ></path>
                        <path
                          d="M6.7,17.286c-.339-.514-.8-.979-1.268-.9s-.791.917-1.092,1.168-1.456.025-1.808.4-.025,1.719-.088,2.36-.4.979-.439,1.28.063.64.628.841,2.674.728,3.4.891,2.435,1.243,3.239-.062a2.193,2.193,0,0,0-.477-2.75A33.772,33.772,0,0,1,6.7,17.286Z"
                          fill="currentColor"
                        ></path>
                        <path
                          d="M11.691,21.674a6.427,6.427,0,0,1-.666-.035,3.216,3.216,0,0,1,.02,1.059,13.928,13.928,0,0,1,2.583.092,4.6,4.6,0,0,1,.082-1.626A4.188,4.188,0,0,1,11.691,21.674Z"
                          fill="currentColor"
                        ></path>
                        <path
                          d="M21.536,19.734a2.4,2.4,0,0,1-1.217-1.255c-.113-.5-.013-.967-.4-1.268s-1.659.273-2.409.18c-.526-.066-1.31-.889-1.845-.548-.318.2-.152,1.008-.14,1.435a22.877,22.877,0,0,1-.188,2.561c-.088.489-.766,2.033.552,2.912a2.014,2.014,0,0,0,2.461-.54,7.4,7.4,0,0,1,1.87-1.393,4.616,4.616,0,0,0,1.67-1.054C22.089,20.425,22.064,20.035,21.536,19.734Z"
                          fill="currentColor"
                        ></path>
                      </g>
                    </svg>
                    Linux
                  </a>
                </li>
                <li class="dropdown-item">
                  <a
                    href="https://static.near-reality.com/Near-Reality-aarch64.AppImage"
                    target="_blank"
                    file
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      class="mr-2"
                    >
                      <g fill="currentColor">
                        <path
                          d="M16.59,15.359a4.464,4.464,0,0,1,.979.432c.067.037.13.076.192.108.16-.015.419-.069.633-.114a5.774,5.774,0,0,1,1.171-.162,2.413,2.413,0,0,1,.4.035,7.268,7.268,0,0,0-.022-1.065A8.384,8.384,0,0,0,18.1,10.262c-.942-1.035-2.391-2.523-2.391-3.653V3.474a3.475,3.475,0,0,0-6.949,0V8.041c-.151.79-.546.866-1.167,1.732a10.318,10.318,0,0,0-1.45,2.674c-.29.87-.905,1.788-1.186,2.511a2.034,2.034,0,0,1,.23-.057,2.183,2.183,0,0,1,.34-.027,2.293,2.293,0,0,1,1.139.313A16.567,16.567,0,0,1,8.763,10.3a4.509,4.509,0,0,0,.7-2.918c.364.29.727,1.192,1.719,1.192S12.837,7.8,13.389,7.52a1.5,1.5,0,0,0,.382-.274l.095.022a46.862,46.862,0,0,1,2.3,4.915A11.1,11.1,0,0,1,16.59,15.359ZM10.94,5.274a2.247,2.247,0,0,0-.466.148l-.077.036a2.478,2.478,0,0,0-.376.216h0a1.325,1.325,0,0,1-.342-.826c-.049-.58.205-1.076.566-1.106s.693.416.742,1A1.571,1.571,0,0,1,10.94,5.274Zm2.4-.418a1.6,1.6,0,0,1-.279.8c-.057-.03-.12-.061-.185-.092l-.049-.024c-.078-.036-.162-.07-.252-.1l-.01,0a3.2,3.2,0,0,0-.678-.167,1.77,1.77,0,0,1-.038-.537c.055-.654.433-1.156.845-1.121S13.4,4.2,13.34,4.856Z"
                          fill="currentColor"
                        ></path>
                        <path
                          d="M6.7,17.286c-.339-.514-.8-.979-1.268-.9s-.791.917-1.092,1.168-1.456.025-1.808.4-.025,1.719-.088,2.36-.4.979-.439,1.28.063.64.628.841,2.674.728,3.4.891,2.435,1.243,3.239-.062a2.193,2.193,0,0,0-.477-2.75A33.772,33.772,0,0,1,6.7,17.286Z"
                          fill="currentColor"
                        ></path>
                        <path
                          d="M11.691,21.674a6.427,6.427,0,0,1-.666-.035,3.216,3.216,0,0,1,.02,1.059,13.928,13.928,0,0,1,2.583.092,4.6,4.6,0,0,1,.082-1.626A4.188,4.188,0,0,1,11.691,21.674Z"
                          fill="currentColor"
                        ></path>
                        <path
                          d="M21.536,19.734a2.4,2.4,0,0,1-1.217-1.255c-.113-.5-.013-.967-.4-1.268s-1.659.273-2.409.18c-.526-.066-1.31-.889-1.845-.548-.318.2-.152,1.008-.14,1.435a22.877,22.877,0,0,1-.188,2.561c-.088.489-.766,2.033.552,2.912a2.014,2.014,0,0,0,2.461-.54,7.4,7.4,0,0,1,1.87-1.393,4.616,4.616,0,0,0,1.67-1.054C22.089,20.425,22.064,20.035,21.536,19.734Z"
                          fill="currentColor"
                        ></path>
                      </g>
                    </svg>
                    Linux Arm
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="d-flex flex-column align-items-center justify-content-center text-center mx-2"
          >
            <a
              href="https://static.near-reality.com/NearReality.jar"
              target="_blank"
              class="btn p-3"
              file
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                height="48"
                width="48"
              >
                <g fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.99998 41C10.6569 41 12 39.6569 12 38L11.9999 28.0001L14.9999 28L15 38C15 41.3137 12.3137 44 8.99995 44C5.68628 44 3.00004 41.3137 3.00004 38V36.0001H6.00004V38C6.00004 39.6568 7.34315 41 8.99998 41Z"
                    fill="currentColor"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M27.5 40.5H19.5V37.5H23.5H27.5V40.5Z"
                    fill="currentColor"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M25.3655 28H21.6374L16.2527 44H20.0009V42.268L23.5 31.8708L27.0014 42.3049V44H30.7346L25.3655 28Z"
                    fill="currentColor"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M37.2154 38.5H33V35.5H38.7846L44.6871 44H40V42.51L37.2154 38.5Z"
                    fill="currentColor"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M32 28H37.75C40.6495 28 43 30.3505 43 33.25C43 36.1495 40.6495 38.5 37.75 38.5H35V44H32V28ZM35 35.5H37.75C38.9926 35.5 40 34.4926 40 33.25C40 32.0074 38.9926 31 37.75 31H35V35.5Z"
                    fill="currentColor"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.2426 2C19.1818 2 18.1644 2.42143 17.4142 3.17157L7.17157 13.4142C6.42153 14.1643 6 15.1812 6 16.2422V25H42V7.9991C42 4.68516 39.3135 2 36 2H20.2426ZM20 16V5L9 16H20Z"
                    fill="currentColor"
                  />
                </g>
              </svg>
              <span class="sr-only">Download Jar Client</span>
            </a>
            <span class="mt-2 text-primary">Jar Client</span>
          </div>
          <div
            class="d-flex flex-column align-items-center justify-content-center text-center mx-2 play-dropdown mac-dropdown"
          >
            <div class="dropdown">
              <a
                id="MacMenu"
                class="dropdown-toggle bg-transparent d-flex flex-column align-items-center justify-content-center"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                data-bs-display="static"
                aria-expanded="false"
              >
                <div class="btn p-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                    height="48"
                    width="48"
                  >
                    <g>
                      <path
                        fill="currentColor"
                        d="M42.998,35.227c-1.039,2.301-1.535,3.328-2.873,5.361c-1.864,2.839-4.494,6.375-7.753,6.405 c-2.895,0.027-3.639-1.884-7.569-1.861S20.054,47.027,17.159,47c-3.259-0.029-5.749-3.222-7.615-6.063 c-5.216-7.94-5.761-17.257-2.544-22.21c2.286-3.522,5.894-5.58,9.285-5.58c3.453,0,5.624,1.893,8.48,1.893 c2.77,0,4.457-1.896,8.45-1.896c3.018,0,6.216,1.643,8.495,4.482C34.243,21.717,35.457,32.376,42.998,35.227L42.998,35.227z"
                      />
                      <path
                        fill="currentColor"
                        d="M30.607,8.176C32.058,6.314,33.158,3.687,32.758,1c-2.37,0.162-5.14,1.67-6.758,3.635 c-1.469,1.783-2.682,4.428-2.21,6.999C26.375,11.715,29.052,10.17,30.607,8.176L30.607,8.176z"
                      />
                    </g>
                  </svg>
                </div>
                <span class="sr-only">Download for Mac</span>
                <span class="mt-2 text-primary">Mac</span>
              </a>
              <ul
                class="dropdown-menu dropdown-menu-end py-3"
                aria-labelledby="MacMenu"
              >
                <li class="dropdown-item mb-2">
                  <a
                    href="https://static.near-reality.com/Near-Reality-x64.dmg"
                    target="_blank"
                    file
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      class="mr-2"
                    >
                      <g fill="currentColor">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.3091 6.48971C13.8886 6.26249 14.614 6.00143 15.6913 6.00143C17.3749 6.00143 19.1523 6.89003 20.3404 8.35613L21.0976 9.29055L20.0406 9.86449C17.5093 11.2391 17.8608 14.8633 20.4912 15.8476L21.4953 16.2234L21.0506 17.199C20.5752 18.2418 20.3284 18.7499 19.6885 19.7119C18.7074 21.192 17.3565 22.9787 15.3958 22.997C14.1793 23.0084 13.2116 22.1656 12.0053 22.172C10.7909 22.1784 9.80329 23 8.57946 22.9999L8.57073 22.9999C6.64549 22.9829 5.31146 21.3315 4.3393 19.8664C1.80437 16.0461 1.46451 11.568 3.19812 8.92508C4.43251 7.04322 6.3164 6.00413 8.20878 6.00413C9.15354 6.00413 9.91949 6.26847 10.5172 6.47873C11.1502 6.70144 11.5462 6.84 11.9823 6.84C12.4376 6.84 12.7407 6.71256 13.3091 6.48971Z"
                          fill="currentColor"
                        ></path>
                        <path
                          d="M15.3653 3.793C16.0815 2.87425 16.5703 1.63176 16.373 0.305766C15.203 0.386016 13.89 1.07576 13.0913 2.0455C12.3668 2.92525 11.7675 4.231 12 5.5C13.2765 5.53975 14.598 4.77775 15.3653 3.793Z"
                          fill="currentColor"
                        ></path>
                      </g>
                    </svg>
                    MacOS (Intel)
                  </a>
                </li>
                <li class="dropdown-item">
                  <a
                    href="https://static.near-reality.com/Near-Reality-aarch64.dmg"
                    target="_blank"
                    file
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      class="mr-2"
                    >
                      <g fill="currentColor">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.3091 6.48971C13.8886 6.26249 14.614 6.00143 15.6913 6.00143C17.3749 6.00143 19.1523 6.89003 20.3404 8.35613L21.0976 9.29055L20.0406 9.86449C17.5093 11.2391 17.8608 14.8633 20.4912 15.8476L21.4953 16.2234L21.0506 17.199C20.5752 18.2418 20.3284 18.7499 19.6885 19.7119C18.7074 21.192 17.3565 22.9787 15.3958 22.997C14.1793 23.0084 13.2116 22.1656 12.0053 22.172C10.7909 22.1784 9.80329 23 8.57946 22.9999L8.57073 22.9999C6.64549 22.9829 5.31146 21.3315 4.3393 19.8664C1.80437 16.0461 1.46451 11.568 3.19812 8.92508C4.43251 7.04322 6.3164 6.00413 8.20878 6.00413C9.15354 6.00413 9.91949 6.26847 10.5172 6.47873C11.1502 6.70144 11.5462 6.84 11.9823 6.84C12.4376 6.84 12.7407 6.71256 13.3091 6.48971Z"
                          fill="currentColor"
                        ></path>
                        <path
                          d="M15.3653 3.793C16.0815 2.87425 16.5703 1.63176 16.373 0.305766C15.203 0.386016 13.89 1.07576 13.0913 2.0455C12.3668 2.92525 11.7675 4.231 12 5.5C13.2765 5.53975 14.598 4.77775 15.3653 3.793Z"
                          fill="currentColor"
                        ></path>
                      </g>
                    </svg>
                    MacOS (Apple Silicon)
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p class="text-center sr-only">
          For Windows users, we recommend the Windows Installer for a
          hassle-free setup with Java included.
        </p>
        <p class="text-center sr-only">
          The <span>.jar</span> client is compatible with all operating systems.
          Requires
          <a
            href="https://www.oracle.com/java/technologies/downloads/#java11-windows"
            target="_blank"
            class="text-white"
          >
            Java 11
          </a>
          installed on your system.
        </p>

        <p class="text-center">
          By downloading Near Reality you agree to our
          <router-link to="/terms" class="text-white">
            Terms of Service
          </router-link>
          .
        </p>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  created() {
    document.title = "Play - Near-Reality";
  },
};
</script>
